/**
 * Manually add polyfills not inserted by "@babel/preset-env"
 */
//@ts-expect-error
import { WeakRef, FinalizationGroup } from '@ungap/weakrefs'
//@ts-expect-error
import structuredClone from '@ungap/structured-clone'
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill'
import { countryFlagEmojiPolyfill } from '@jotta/ui/FontConfig'

const twemojiFontUrl = new URL(
  '../../../node_modules/country-flag-emoji-polyfill/dist/TwemojiCountryFlags.woff2',
  import.meta.url,
).href

if (!('structuredClone' in globalThis)) {
  ;(globalThis as any).structuredClone = structuredClone
}
if (!('WeakRef' in globalThis)) {
  ;(globalThis as any).WeakRef = WeakRef
}
if (!('FinalizationGroup' in globalThis)) {
  ;(globalThis as any).FinalizationGroup = FinalizationGroup
}
polyfillCountryFlagEmojis(countryFlagEmojiPolyfill, twemojiFontUrl)
